import { Select, SelectProps } from "@mantine/core"
import { AuthenticationFactorType } from "../../../@client/Theasoft_DataTypes_Enums"
import { useGetAllowedAuthenticationFactors } from "./use-get-allowed-authentication-factors"
import { useTranslation } from "react-i18next"
import useGetLocalizedAuthenticationFactorType from "./use-get-localized-authentication-factor-type"

interface Props extends Omit<SelectProps, "value" | "onChange" | "data"> {
  value: AuthenticationFactorType
  onChange: (value: AuthenticationFactorType | null) => void
}

export function SelectAuthenticationFactorType({ onChange, ...props }: Props) {
  const { data: allowedAuthenticationFactorTypes } =
    useGetAllowedAuthenticationFactors()
  const { t } = useTranslation("app_server")
  const getLocalizedAuthenticationFactorType =
    useGetLocalizedAuthenticationFactorType()

  return (
    <Select
      required
      readOnly={allowedAuthenticationFactorTypes.length === 1}
      label={t("AuthenticationFactorType")}
      data={allowedAuthenticationFactorTypes.map((type) => ({
        label: getLocalizedAuthenticationFactorType(type),
        value: type,
      }))}
      onChange={(value) =>
        onChange(value ? (value as AuthenticationFactorType) : null)
      }
      {...props}
    />
  )
}
